export default __webpack_public_path__ + "locales/lv/FilesSettings.json?hash=960ea5c2ce47192b27d6051c7c517d02";